export const submitRecaptcha = e => {
  e.preventDefault();

  window.grecaptcha.ready(function () {
    window.grecaptcha
      .execute(process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY, {
        action: 'submit',
      })
      .then(async function (token) {
        // Add your logic to submit to your backend server here.
        // Check token
        const response = await fetch('/.netlify/functions/recaptcha', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: token,
          }),
        });

        const recaptchaResponse = await response.json();

        if (recaptchaResponse.score >= 0.5) {
          const form = e.target;
          const formData = new FormData(form);

          await fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(formData).toString(),
          }).catch(error => console.log(error));
        }
      });
  });
};
